window.addEventListener("DOMContentLoaded", () => {
    const video = document.querySelector('.video-el-src')
    const videoBtn = document.querySelector('.control')
    const popup = document.querySelector('.popup-video')
    const closeBtn = document.querySelector('.popup-video > .inside-wrapper > span')

    videoBtn?.addEventListener('click', () => {
        playVideo()

        if (videoBtn.getAttribute('listener') !== 'true'){
            videoBtn.setAttribute('listener', 'true')
        }
    })

    closeBtn?.addEventListener('click', () => {
        pauseVideo()
    })

    function playVideo() {
        if (video) video.play();
        videoBtn.classList.add('hidden')
        popup.classList.add('is-visible')
    }

    function pauseVideo() {
        if (video) video.pause()
        videoBtn.classList.remove('hidden')
        popup.classList.remove('is-visible')
    }
});
